<template>
    <div class="row">
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-4 col-xl-8 offset-xl-2">
            <p class="content-text--spotlight" v-html="value"></p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Quote',
    props:['value']
}
</script>